import SEO from "../components/SEO";

export default function NabhCompliance() {
  return (
     <>
    <SEO/>
    <div style={{ paddingTop: 68 }}>
      {/* Hero Section */}
      <section style={{ padding: '80px 24px', textAlign: 'center', background: '#F6F7FC' }}>
        <h1 style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize: 48, color: '#343F86' }}>
          NABH Compliance Consulting
        </h1>
        <p style={{ fontSize: 17, color: '#5B6072', maxWidth: 640, margin: '16px auto 0' }}>
          Design and build hospital infrastructure that meets National Accreditation Board
          for Hospitals & Healthcare Providers (NABH) standards — from layout to patient safety systems.
        </p>
      </section>

      {/* What is NABH */}
      <section style={{ padding: '64px 24px', maxWidth: 900, margin: '0 auto' }}>
        <h2 style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize: 30, marginBottom: 16 }}>
          What is NABH?
        </h2>
        <p style={{ fontSize: 15, color: '#3A4060', lineHeight: 1.7 }}>
          NABH is a constituent board of the Quality Council of India that sets and certifies
          standards for healthcare quality and patient safety. Accreditation covers clinical
          processes, infection control, infrastructure design, staff competency, and continuous
          quality improvement — helping hospitals build trust with patients, insurers, and regulators.
        </p>
      </section>

      {/* Services Grid */}
      <section style={{ padding: '64px 24px', background: '#F6F7FC' }}>
        <h2 style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize: 30, textAlign: 'center', marginBottom: 40 }}>
          Our NABH Compliance Services
        </h2>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
          gap: 24,
          maxWidth: 1100,
          margin: '0 auto'
        }}>
          {[
            { title: 'Infrastructure Audit', desc: 'Assessment of existing facility layout against NABH infrastructure checklists.' },
            { title: 'OT & ICU Layout Design', desc: 'Compliant operation theatre and ICU zoning, airflow, and space planning.' },
            { title: 'Fire & Life Safety', desc: 'Fire exits, alarm systems, and evacuation planning per NABH norms.' },
            { title: 'Infection Control Design', desc: 'Isolation rooms, HVAC pressure zones, and material selection for hygiene.' },
            { title: 'Biomedical Waste Management', desc: 'Segregation, storage, and disposal infrastructure setup.' },
            { title: 'Documentation Support', desc: 'Drawings, SOPs, and infrastructure records needed for NABH submission.' },
          ].map((item, i) => (
            <div key={i} style={{
              background: '#fff',
              padding: 28,
              borderRadius: 8,
              boxShadow: '0 1px 6px rgba(0,0,0,0.06)'
            }}>
              <h3 style={{ fontSize: 18, marginBottom: 8, color: '#343F86' }}>{item.title}</h3>
              <p style={{ fontSize: 14, color: '#5B6072', lineHeight: 1.6 }}>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section style={{ padding: '64px 24px', textAlign: 'center' }}>
        <h2 style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize: 28, marginBottom: 16 }}>
          Planning a NABH-Accredited Facility?
        </h2>
        <p style={{ fontSize: 15, color: '#5B6072', marginBottom: 24 }}>
          Talk to our team about designing infrastructure that meets NABH standards from day one.
        </p>
        <button className="btn-primary">Book a Consultation</button>
      </section>
    </div>
    </>
  );
}